import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalContent, ModalTitle } from '@twnel/web-components';
import AceEditorInput from './AceEditorInput';

const SpecVisualizer = ({ onClose, specJson }) => {
  const hideMetaFields = (spec) => {
    const specJSON = JSON.parse(spec);
    Object.keys(specJSON.actions).forEach((key) => {
      const action = specJSON.actions[key];
      if (action.type === 'call_api' && action.eval?.integration) {
        delete action.eval.params;
        delete action.eval.headers;
      }
    });
    return JSON.stringify(specJSON, null, 2);
  };
  return (
    <Modal height="90%" width={900} onClose={onClose} modalStatic>
      <ModalTitle data-testid="modal-title">Spec Visualizer</ModalTitle>
      <ModalContent>
        <AceEditorInput
          height="100%"
          value={hideMetaFields(specJson)}
          disabled
        />
      </ModalContent>
    </Modal>
  );
};

SpecVisualizer.defaultProps = {
  specJson: '',
};

SpecVisualizer.propTypes = {
  onClose: PropTypes.func.isRequired,
  specJson: PropTypes.string,
};

export default SpecVisualizer;
